import * as React from 'react';
import styled from 'styled-components';
import { IconContext } from 'react-icons';
import { Flex } from './ui';
import WalletInfo from 'components/WalletInfo'
import { useWallet } from './WalletContext';
import walletIcon from 'img/wallet.svg';

const Connect = styled.div`
  color: ${props => props.theme.colors.copy};
  font-weight: 600;
  cursor: pointer;
`;

const Wallet: React.FC = () => {
  const { selectWallet, logoutWallet, address } = useWallet();

  return (
    <IconContext.Provider value={{ style: { alignSelf: 'center' }, size: '18px' }}>
      <Flex pr={2}>
        {address ? (
          <WalletInfo address={address} onLogout={logoutWallet} />
        ) : (
          <Connect onClick={selectWallet}>
            <img src={walletIcon} width="24px" alt="Connect wallet" />
          </Connect>
        )}
      </Flex>
    </IconContext.Provider>
  );
};

export default Wallet;
